import type { ReactNode } from 'react';

export const symbol_cloud_done: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m413-360-80-80q-8-8-20.5-7.5T292-439q-8 8-8 20.5t8 20.5l99 98q9 9 21 9t21-9l189-189q8-8 8-20t-8-20q-8-8-20-8t-20 8L413-360ZM251-160q-88 0-149.5-61.5T40-371q0-78 50-137t127-71q20-97 94-158.5T482-799q112 0 189 81.5T748-522v24q72-2 122 46.5T920-329q0 69-50 119t-119 50H251Zm0-60h500q45 0 77-32t32-77q0-45-32-77t-77-32h-63v-84q0-91-61-154t-149-63q-88 0-149.5 63T267-522h-19q-62 0-105 43.5T100-371q0 63 44 107t107 44Zm229-260Z"
		/>
	</svg>
);
